import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { FloatApp } from './FloatApp';
import { createEnvironment } from './data/backend';
import { detectLanguage } from './domain/settings';
import { initI18n } from './i18n';
import { browserStorage, captureAdIds } from './platform/adAttribution';
import { captureEntry } from './platform/entryParams';
import { initPwa } from './platform/pwa';
import { getDesktop } from './platform/desktop';
import { SetupMissing } from './ui/SetupMissing';
import './styles.css';

async function boot() {
  const root = createRoot(document.getElementById('root')!);
  const desktop = await getDesktop();
  // A janela "float" do Tauri só desenha a barra flutuante.
  if (desktop?.label === 'float') {
    root.render(
      <StrictMode>
        <FloatApp bridge={desktop} />
      </StrictMode>
    );
    return;
  }
  // versão web: guarda os identificadores do anúncio que o site repassou (AC-250)
  const storage = browserStorage();
  if (!desktop && storage) captureAdIds(location.href, storage, (url) => history.replaceState(null, '', url));
  // versão web: veio do site para criar a conta e assinar — "Criar conta" e o plano escolhido (AC-257)
  if (!desktop) captureEntry(location.href, storage, (url) => history.replaceState(null, '', url));
  // versão web instalável no celular (AC-251)
  if (!desktop) initPwa();
  const i18n = initI18n(detectLanguage(navigator.languages ?? [navigator.language]));
  const env = await createEnvironment(desktop);
  if (!env) {
    root.render(<SetupMissing title={i18n.t('setup.title')} body={i18n.t('setup.body')} />);
    return;
  }
  root.render(
    <StrictMode>
      <App env={env} />
    </StrictMode>
  );
}

void boot();
